<script lang="ts">
  import CheckmarkFilled from 'carbon-icons-svelte/lib/CheckmarkFilled16';
  import CloseFilled from 'carbon-icons-svelte/lib/CloseFilled16';

  export let value: boolean | null | undefined = undefined,
    size: string | number = 16;

  $: dimension = typeof size === 'number' ? `${size}px` : size;
</script>

{#if value}
  <span class="boolean-icon boolean-icon--true">
    <CheckmarkFilled style="width: {dimension}; height: {dimension}" title="Yes" />
  </span>
{:else if value === false}
  <span class="boolean-icon boolean-icon--false">
    <CloseFilled style="width: {dimension}; height: {dimension}" title="No" />
  </span>
{:else}
  <span>—</span>
{/if}

<style>
  .boolean-icon {
    display: inline-flex;
    align-items: center;
  }

  .boolean-icon--true {
    color: var(--cds-support-02);
  }

  .boolean-icon--false {
    color: var(--cds-danger-01);
  }
</style>
